import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import { getReleaseStage } from '@general/env';

export const initBugsnag = () => {
    Bugsnag.start({
        enabledReleaseStages: ['production', 'stage'],
        apiKey: process.env.BUGSNAG_API_KEY_MY_ICSC,
        plugins: [new BugsnagPluginReact()],
        releaseStage: getReleaseStage(),
    });
};
